export const browser = typeof window !== 'undefined';
